import { forwardRef } from "react";
import styles from "@/styles/Form.module.scss";
import IconCheck from "../../../svgs/icon_check.svg";

const MetaSelectorField = forwardRef((props, ref) => {
  const { name, defaultChecked, ..._props } = props;
  return (
    <div className={styles.metaSelectorField}>
      <div className={styles.metaSelector}>
        <input
          ref={ref}
          id={`checkbox-${name}`}
          name={name}
          type="checkbox"
          defaultChecked={defaultChecked}
          {..._props}
        />
        <label htmlFor={`checkbox-${name}`} className={styles.label}>
          <span>
            <IconCheck />
          </span>
        </label>
      </div>
    </div>
  );
});
MetaSelectorField.displayName = "MetaSelectorField";
export default MetaSelectorField;
